<template>
  <div class="box-profile">
    <div class="inp-box" v-for="item in inpList" :key="item.id">
      <label>{{ item.label }}</label>
      <div class="box-wrap-inp" v-if="item.type === 'input'">
        <input
          type="text"
          :disabled="!item.isEdit"
          v-model="item.data"
          :ref="item.key"
          @blur="handleBlur(item)"
        />
        <span v-if="!item.isHide" @click="handleEdit(item)">修改</span>
      </div>
      <div class="box-wrap-radio" v-else-if="item.type === 'radio'">
        <div
          class="radio-wrap"
          v-for="(radio, index) in item.text"
          :key="index"
          @click="handleRadio(index, item)"
        >
          <i :class="{ radioActive: index === radioActive }"></i>
          <span>{{ radio }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userEditInfo, userinfo } from "@/api/UserCenter";

export default {
  name: "Profile",
  props: {
    userObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      radioActive: 0,
      inpList: [],
      profile: {
        avatar: "",
        nickname: "",
        phone: "",
        sex: 0,
        cardId: "",
      },
    };
  },
  watch: {
    userObj: {
      handler(newVal) {
        this.syncProfile(newVal || {});
      },
      immediate: true,
    },
  },
  methods: {
    syncProfile(user = {}) {
      this.profile = {
        avatar: user.avatar || "",
        nickname: user.nickname || "",
        phone: user.phone || "",
        sex: Number(user.sex) === 1 ? 1 : 0,
        cardId: user.cardId || "",
        studentNumber: user.studentNumber || "",
      };
      this.radioActive = this.profile.sex;
      this.inpList = [
        {
          id: 0,
          label: "昵称",
          isEdit: false,
          type: "input",
          data: this.profile.nickname,
          key: "nickname",
        },
        {
          id: 1,
          label: "用户编号",
          isEdit: false,
          type: "input",
          isHide: true,
          data: this.profile.studentNumber,
          key: "studentNumber",
        },
        {
          id: 2,
          label: "手机号",
          isEdit: false,
          type: "input",
          data: this.profile.phone,
          key: "phone",
        },
        {
          id: 3,
          label: "性别",
          isEdit: false,
          type: "radio",
          text: ["男", "女"],
          data: this.profile.sex,
          key: "sex",
        },
        {
          id: 4,
          label: "身份证号",
          isEdit: false,
          type: "input",
          data: this.profile.cardId,
          key: "cardId",
        },
      ];
    },
    isMobile(value) {
      return /^1[3-9]\d{9}$/.test(value);
    },
    isIdCard(value) {
      return /^(\d{15}|\d{17}[\dXx])$/.test(value);
    },
    buildPayload(extra = {}) {
      const payload = {
        sex: this.radioActive,
      };
      if (this.profile.avatar) {
        payload.avatar = this.profile.avatar;
      }
      if (this.profile.nickname) {
        payload.nickname = this.profile.nickname;
      }
      if (this.profile.phone) {
        payload.phone = this.profile.phone;
      }
      if (this.profile.cardId) {
        payload.cardId = this.profile.cardId;
      }
      return {
        ...payload,
        ...extra,
      };
    },
    handleRadio(index, item) {
      this.radioActive = index;
      this.profile.sex = index;
      this.userEditInfoFunc(this.buildPayload(), item);
    },
    handleBlur(item) {
      const value = (item.data || "").trim();

      if (item.key === "studentNumber") {
        item.isEdit = false;
        return;
      }

      if (!value) {
        this.$message.error("内容不能为空");
        this.getFocus(item.key);
        return;
      }

      if (item.key === "phone" && !this.isMobile(value)) {
        this.$message.error("请输入正确的手机号");
        this.getFocus(item.key);
        return;
      }

      if (item.key === "cardId" && !this.isIdCard(value)) {
        this.$message.error("请输入正确的身份证号");
        this.getFocus(item.key);
        return;
      }

      if (item.key === "nickname") {
        this.profile.nickname = value;
      }
      if (item.key === "phone") {
        this.profile.phone = value;
      }
      if (item.key === "cardId") {
        this.profile.cardId = value.toUpperCase();
        item.data = this.profile.cardId;
      }

      this.userEditInfoFunc(this.buildPayload(), item);
    },
    userEditInfoFunc(payload, item) {
      userEditInfo(payload)
        .then(() => {
          this.$message.success("修改成功");
          this.updateUserInfo();
          if (item) {
            item.isEdit = false;
          }
        })
        .catch((err) => {
          this.$message.error(err?.msg || "修改失败");
        });
    },
    updateUserInfo() {
      userinfo({ login: true })
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem("nickname", res.data.nickname || "");
            this.$store.commit("UPDATE_USERINFO", res.data);
            this.syncProfile(res.data);
          }
        })
        .catch(() => {});
    },
    handleEdit(item) {
      item.isEdit = true;
      this.getFocus(item.key);
    },
    getFocus(key) {
      this.$nextTick(() => {
        const ref = this.$refs[key];
        if (ref && ref[0]) {
          ref[0].focus();
        }
      });
    },
  },
};
</script>

<style lang="scss">
.box-profile {
  padding-top: 30px;
  .inp-box {
    display: flex;
    justify-content: left;
    margin-bottom: 36px;
    label {
      font-size: 13px;
      color: #7f7f7f;
      width: 94px;
      line-height: 37px;
    }
    .box-wrap-inp {
      width: 324px;
      height: 37px;
      border: 1px solid #f2f2f2;
      border-radius: 6px;
      input {
        border: none;
        background-color: transparent;
        box-sizing: border-box;
        width: 280px;
        height: 35px;
        text-indent: 14px;
        color: #7f7f7f;
      }
      span {
        display: inline-block;
        line-height: 37px;
        font-size: 13px;
        color: #7f7f7f;
        cursor: pointer;
      }
    }
    .box-wrap-radio {
      height: 37px;
      line-height: 37px;
      display: flex;
      justify-content: left;
      .radio-wrap {
        display: flex;
        justify-content: left;
        align-items: center;
        margin-right: 24px;
        cursor: pointer;
        i {
          width: 12px;
          height: 12px;
          border: 1px solid #aaa;
          border-radius: 50%;
          margin-right: 6px;
        }
        i.radioActive {
          width: 12px;
          height: 12px;
          border: 1px solid #7a2489;
          border-radius: 50%;
          margin-right: 6px;
          position: relative;
          &::after {
            content: "";
            width: 6px;
            height: 6px;
            background-color: #7a2489;
            position: absolute;
            left: 2px;
            top: 2px;
            border-radius: 50%;
          }
        }
        span {
          font-size: 13px;
          color: #333;
        }
      }
    }
  }
}

@media (max-width: 900px) {
  .box-profile {
    padding-top: 18px;

    .inp-box {
      display: block;
      margin-bottom: 18px;

      label {
        display: block;
        width: 100%;
        margin-bottom: 8px;
        line-height: 1.4;
      }

      .box-wrap-inp {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;

        input {
          flex: 1 1 auto;
          min-width: 0;
          width: auto;
          height: 38px;
        }

        span {
          flex: 0 0 auto;
          padding: 0 12px;
          line-height: 38px;
        }
      }

      .box-wrap-radio {
        height: auto;
        line-height: 1;
        gap: 18px;
      }
    }
  }
}
</style>
